import { LoadingButton } from '@atlaskit/button';
import CheckIcon from '@atlaskit/icon/glyph/check-circle';
import React from 'react';
import { FormData } from '../subscription-txa-transfer-pane';
import './progress-form.scss';
import { defaultTo } from 'lodash';
import capitalize from 'lodash/capitalize';
import { BillingAccount, AddressCell, BillingAdminCell } from './billing-account-table';
import { DynamicResultTable } from '@css-xp/base';
import { NO_DETAILS_TO_SHOW } from '@atlassian/cssxp-utils-entitlement';

type Props = {
  formState: FormData;
  changeBillingAccount: () => void;
  isChangeAvailable?: boolean;
};

export const emptyStateOrderProp = {
  header: '',
  description: NO_DETAILS_TO_SHOW,
  imageUrl: '',
};

export const SelectedBillingAccountTable = ({ formState, changeBillingAccount, isChangeAvailable = true }: Props) => {
  const results = [formState.selectedBillingAccount];

  const wrapInCell = (node: React.ReactElement | string) => {
    return <div className="pv-8">{node}</div>;
  };

  const getRows = () => {
    return results.map((billingAccount: any) => {
      return {
        key: billingAccount?.id,
        cells: [
          {
            content: wrapInCell(<BillingAccount billingAccount={billingAccount} />),
          },
          {
            content: wrapInCell(<AddressCell billingAccount={billingAccount} />),
          },
          {
            content: wrapInCell(defaultTo(billingAccount?.billToParty?.taxId, 'Not provided')),
          },
          {
            content: wrapInCell(<BillingAdminCell billingAccount={billingAccount} />),
          },
          {
            content: wrapInCell(
              billingAccount?.billToPartyPricingEligibilty ? (
                capitalize(billingAccount?.billToPartyPricingEligibilty)
              ) : (
                <div aria-label="Not applicable">-</div>
              )
            ),
          },
          {
            key: `${billingAccount?.id}-actions`,
            params: billingAccount,
            content: (
              <>
                {isChangeAvailable && (
                  <div className="select-acount-actions">
                    <LoadingButton
                      appearance="link"
                      spacing="compact"
                      onClick={() => changeBillingAccount()}
                      testId="change-transaction-account"
                    >
                      Change
                    </LoadingButton>
                  </div>
                )}
              </>
            ),
          },
        ],
      };
    });
  };

  const getHead = () => {
    const cells = [
      {
        content: 'Billing account',
        width: 20,
      },
      {
        content: 'Billing address',
        width: 23,
      },
      {
        content: 'Tax ID',
        width: 15,
      },
      {
        content: 'Billing admins',
        width: 20,
        shouldTruncate: true,
      },
      {
        content: 'Pricing',
        width: 10,
      },
      {
        content: '',
      },
    ];

    return {
      cells,
    };
  };

  return (
    <div className="plan-view selected-table" data-testid="select-billing-account-view">
      <h2>
        <CheckIcon label="" size="medium" testId="icon-bill-admin" /> Billing account{' '}
      </h2>
      <DynamicResultTable
        head={getHead()}
        rows={getRows()}
        testId="contact-billing-accounts"
        emptyStateProps={emptyStateOrderProp}
        boxShadow={false}
      />
    </div>
  );
};
